import React from "react";

const HistorySummaryTable = ({
  historySummaryInfo,
  startDateSummary,
  addCommas,
  balanceForward,
}) => {
  //Variables
  let headers,
    headersDays = [],
    winLossTd = [],
    cashInOutAmountTd = [],
    balanceTd = [],
    month,
    year,
    arrayWonLoss = [],
    arrayCashInOut = [],
    arrayBalance = [],
    totalWonLoss = [],
    totalCashInOut = [],
    totalBalance = [];

  month = new Date(startDateSummary).toLocaleString("default", {
    month: "short",
  });
  month = month.charAt(0).toUpperCase() + month.slice(1);
  year = new Date(startDateSummary).getFullYear();

  const padToTwoDigits = (num) => {
    return num.toString().padStart(2, "0");
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  //Create the headers with the dates consulted in the history Summary
  if (historySummaryInfo) {
    headersDays = historySummaryInfo.map((data, i) => {
      let day = padToTwoDigits(new Date(data.TransactionDate).getUTCDate());
      let formattedDay = capitalizeFirstLetter(data.Day);
      return (
        <th key={i}>
          {formattedDay} {day}
        </th>
      );
    });

    //Create the content of the table with the history summary information.
    //Won/Loss
    winLossTd = historySummaryInfo.map((element, j) => {
      let winL;
      if (element.WinLossAmount !== 0) {
        winL = parseFloat(element.WinLossAmount).toFixed(2);
      } else {
        winL = "";
      }
      return (
        <td
          key={"winLoss" + j}
          style={{ verticalAlign: "middle", textAlign: "center" }}
          className={"entryTR"}
        >
          {winL !== 0 && addCommas(winL)}
        </td>
      );
    });

    //Cash In/Out
    cashInOutAmountTd = historySummaryInfo.map((element, j) => {
      let cashInOut;
      if (element.CashInOutAmount !== 0) {
        cashInOut = parseFloat(element.CashInOutAmount).toFixed(2);
      } else {
        cashInOut = "";
      }
      return (
        <td
          key={"cashInOut" + j}
          style={{ verticalAlign: "middle", textAlign: "center" }}
          className={"entryTR"}
        >
          {addCommas(cashInOut)}
        </td>
      );
    });

    //Balance
    balanceTd = historySummaryInfo.map((element, j) => {
      let balanceSummary;
      if (element.Balance !== 0) {
        balanceSummary = addCommas(parseFloat(element.Balance).toFixed(2));
      } else {
        balanceSummary = "";
      }
      return (
        <td
          key={"balance" + j}
          style={{ verticalAlign: "middle", textAlign: "center" }}
          className={"entryTR"}
        >
          {balanceSummary}
        </td>
      );
    });
  }

  //Totals for WonLoss, CashInOut, and Balance columns
  if (historySummaryInfo && historySummaryInfo.length > 0) {
    historySummaryInfo.forEach((data) => {
      if (data.WinLossAmount) {
        arrayWonLoss.push(parseFloat(data.WinLossAmount).toFixed(2));
      }

      if (data.CashInOutAmount) {
        arrayCashInOut.push(parseFloat(data.CashInOutAmount).toFixed(2));
      }

      if (data.Balance) {
        arrayBalance.push(parseFloat(data.Balance).toFixed(2));
      }
    });
  }

  totalWonLoss = arrayWonLoss.reduce(
    (a, b) => parseFloat(a) + parseFloat(b),
    0,
  );
  totalCashInOut = arrayCashInOut.reduce(
    (a, b) => parseFloat(a) + parseFloat(b),
    0,
  );
  totalBalance = arrayBalance[arrayBalance.length - 1] ?? 0;

  //Create the headers for table History Summary
  headers = (
    <tr className="text-center header-tbEntries" style={{ color: "#fff" }}>
      <th style={{ width: "100px" }}>
        {month} {year}
      </th>
      <th>BOW</th>
      {headersDays}
      <th>Total</th>
    </tr>
  );

  return (
    <table className="table table-striped table-md">
      <thead
        style={{
          position: "sticky",
          top: "0",
          background: "#005580",
        }}
      >
        {headers}
      </thead>
      <tbody className="table-sm">
        <tr>
          <td
            style={{
              color: "#fff",
              backgroundColor: "#005580",
            }}
          >
            Won/Lost
          </td>
          <td></td>
          {winLossTd}

          <td style={{ textAlign: "center" }}>
            {addCommas(parseFloat(totalWonLoss).toFixed(2))}
          </td>
        </tr>
        <tr>
          <td
            style={{
              color: "#fff",
              backgroundColor: "#005580",
            }}
          >
            Cash In/Out
          </td>
          <td></td>
          {cashInOutAmountTd}
          <td style={{ textAlign: "center" }}>
            {addCommas(parseFloat(totalCashInOut).toFixed(2))}
          </td>
        </tr>
        <tr>
          <td
            style={{
              color: "#fff",
              backgroundColor: "#005580",
            }}
          >
            Balance
          </td>
          <td style={{ textAlign: "center" }}>
            {balanceForward !== 0 &&
              addCommas(parseFloat(balanceForward).toFixed(2))}
          </td>
          {balanceTd}
          <td style={{ textAlign: "center" }}>
            {addCommas(parseFloat(totalBalance).toFixed(2))}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default HistorySummaryTable;
